export type TDoor = {
  title: string;
  image: string;
  doorId: number;
  isLoading: boolean;
  onClickBtn: VoidFunction;
};

export enum EAdventDoorsHashs {
  FirstDoor = '8b04d5e3775d298e78455efc5ca404d5',
  SecondDoor = 'a9f0e61a137d86aa9db53465e0801612',
  ThirdDoor = 'dd5c8bf51558ffcbe5007071908e9524',
  FourthDoor = 'c0759f2416498708841e7975566360ce',
  FifthDoor = '0883a6520e6eb6c9304dcfb71034d053',
  SixthDoor = '93c38fcf0d200be001335ef572650346',
  SeventhDoor = '5098d245aa911c02a50e276087c0b4a9',
  EighthDoor = 'a76a3a8b8cba2cbe41bd4310b12ad2db',
}
